import React from "react";
import Navbar from "../Components/Navbar";
import "./Header.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "../CSS/theme.css";
import "./Contact.css";
import FooterNew from "../Components/FooterNew";
import QuickLinks from "./QuickLinks";
import PhoneForwardedIcon from "@mui/icons-material/PhoneForwarded";

const Contact = () => {
  const CWD = "";
  const heroBgImage = `${CWD}/assets/img/gallery/dr-banner-6.jpg`;
  const allergyimg = `${CWD}/diseasePic/allergy-hand.jpg`;
  return (
    <div
      className="parent-contact"
      style={{ maxWidth: "100%", overflow: "hidden" }}
    >
      <Navbar />
      <div className="Main-Header-Container">
        <section
          className="py-xxl-10 pb-0"
          id="home"
          style={{ background: "rgb(0 0 0 / 60%)", height: "610px" }}
        >
          <div
            className="bg-holder"
            style={{
              backgroundImage: `url(${heroBgImage})`,
              backgroundPosition: "bottom",
              backgroundSize: "cover",

              //   height: "100vh", // Add a height to ensure background is visible
            }}
          />

          <div className="container">
            <div className="row min-vh-xl-100 min-vh-xxl-25">
              <div className=" paddin-header   text-center ">
                <h2 className="">
                  <span
                    className=" general-tittle-mbl"
                    style={{
                      fontSize: "48px",
                      fontFamily: "Raleway, sanf-serif",
                      color: "#fff",
                      paddingBottom: " 10px",
                    }}
                  >
                    Clinic Locations
                  </span>
                </h2>
              </div>
            </div>
          </div>
        </section>
      </div>
      <div className="Genral-main-container text-center mt-7">
        <h1>Contact Detail</h1>
      </div>
      <br />
      <div
        className=" about-summary-inline"
        style={{
          padding: "5px 20px 0px",
          marginBottom: "20px",
          textAlign:"justify",
          fontSize:"19px"
        }}
      >
        <p>
          Dr Ahmed can be contacted through the phone lines for BMI Meriden
          Coventry, Nuffield Health Warwickshire and Spire Leicester. Dr Ahmed does not
          usually take phone calls outside of consultation nor direct email.
        </p>
      </div>

      {/* <div id="location" className="contact-num text-center">
        <a href="tel:+01164905437" className="btn btn-primary btn-sm">
          <PhoneForwardedIcon style={{ marginRight: "5px" }} />
          Call Now
        </a>
      </div> */}

      <br />
      <br />

      <div className="row  text-center">
        <div className="google-map col-lg-6 col-md-12 col-sm-12 ">
          <h3>
          Nuffield Health Warwickshire<br /> CV32 6RW
          </h3>
          <iframe
            className="w-lg-75 w-sm-auto w-md-75  "
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2439.2991778666487!2d-1.5426810234466555!3d52.31057347200702!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x487734e003c59e85%3A0xd402707b8edac53d!2sNuffield%20Health%20Warwickshire%20Hospital!5e0!3m2!1sen!2s!4v1722072464336!5m2!1sen!2s"
            // width="600"
            height="400"
            style={{ border: 0 }}
            allowfullscreen=""
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
          ></iframe>
          <div className="clinic-timing-meriden mt-4">
            <h3>Clinic timing</h3>
          </div>
          <div className="inner-edu-about">
            <ol
              className=""
              style={{
                listStyleType: "disc",
                display: "grid",
                justifyContent: "center",

                marginTop: "20px",
                fontSize: "20px",
                fontWeight: "550",

                letterSpacing: ".225px",
                fontFamily: "Open Sans sans-serif",
              }}
            >
              <li style={{ flex: "1", minWidth: "180px", textAlign: "start" }}>
              Saturday Morning
              </li>
            </ol>
          </div>
          <div>
            <a
              href="https://www.nuffieldhealth.com/consultants/dr-imtiaz-ahmed-warwickshire"
              className=" btn-slide-new"
              style={{ verticalAlign: "middle" }}
              target="_blank"
              rel="noopener noreferrer"
            >
              <span>Appointment </span>
            </a>
          </div>
        </div>

        <div className="2nd-google-map col-lg-6 col-md-12 col-sm-12">
          <h3>
            Spire Leicester Hospital <br /> LE2 2FF
          </h3>
          <iframe
            className="w-lg-75 w-sm-auto w-md-75"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2422.5706594021567!2d-1.0807972884897143!3d52.613530971969396!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x487763ffb1612a57%3A0xa3ba8ad9858d9259!2sSpire%20Leicester%20Hospital!5e0!3m2!1sen!2s!4v1704096361611!5m2!1sen!2s"
            height="400"
            style={{ border: 0 }}
            allowfullscreen=""
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
          ></iframe>
          <div className="clinic-timing-meriden mt-4">
            <h3>Clinic timing</h3>
          </div>
          <div className="inner-edu-about">
            <ol
              className=""
              style={{
                listStyleType: "disc",
                display: "grid",
                // flexWrap: "wrap", // Allow items to wrap to the next line
                justifyContent: "center", // Center the items horizontally
                // alignItems: "center", // Center the items vertically
                // padding: "50px", // Remove default padding
                // margin: "0px 100px", // Add margin for spacing
                // marginLeft: "80px",
                marginTop: "20px",
                // marginBottom: "50px",
                fontSize: "20px",
                fontWeight: "550",

                letterSpacing: ".225px",
                fontFamily: "Open Sans sans-serif",
              }}
            >
              <li style={{ flex: "1", minWidth: "180px", textAlign: "start" }}>
                {/* Tuesday 08:30 – 12:30 */}
                Tuesday Morning
              </li>
            </ol>
          </div>
          <div>
            <a
              href="https://www.spirehealthcare.com/consultant-profiles/dr-imtiaz-ahmed-c4165334/"
              className=" btn-slide-new"
              style={{ verticalAlign: "middle" }}
              target="_blank"
              rel="noopener noreferrer"
            >
              <span>Appointment </span>
            </a>
          </div>
        </div>
      </div>

      <div className="3rd-google-map col-lg-12 col-md-12 col-sm-12 text-center mt-5">
        <h3>
          BMI Meriden Coventry <br /> CV2 2LQ
        </h3>
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2433.089925853618!2d-1.440716679242496!3d52.4231682865019!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48774924cae48393%3A0x5b4a235c682fb6f!2sThe%20Meriden%20Hospital!5e0!3m2!1sen!2s!4v1704091170195!5m2!1sen!2s"
          className="w-lg-75 w-sm-auto w-md-75"
          // width="600"
          height="400"
          style={{ border: 0 }}
          allowfullscreen=""
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
        ></iframe>

        <div className="clinic-timing-meriden mt-4">
          <h3>Clinic timing</h3>
        </div>
        <div className="inner-edu-about">
          <ol
            className=" "
            style={{
              listStyleType: "disc",
              display: "grid",
              // flexWrap: "", // Allow items to wrap to the next line
              justifyContent: "center", // Center the items horizontally
              // alignItems: "center", // Center the items vertically
              // padding: "50px", // Remove default padding
              // margin: "0px 100px", // Add margin for spacing
              // marginLeft: "80px",
              marginTop: "20px",
              // marginBottom: "50px",
              fontSize: "20px",
              fontWeight: "600",
              

              letterSpacing: ".225px",
              fontFamily: "Open Sans sans-serif",
            }}
          >
            <li style={{ flex: "1", minWidth: "160px", textAlign: "start" }}>
              {/* Monday 09:00 – 12:00 */}
              Monday Morning
            </li>
            <li style={{ flex: "1", minWidth: "160px", textAlign: "start" }}>
              {/* Wednesday 13:00-17:00 */}
              Wednesday Morning
            </li>
            {/* <li style={{ flex: "1", minWidth: "160px", textAlign: "start" }}>
              Thursday 17:00-19:30 <br /> (Ad-Hoc Clinics)
              Thursday Morning

            </li> */}
            <li style={{ flex: "1", minWidth: "160px", textAlign: "start" }}>
              {/* Friday 09:00 – 12:00 */}
              Friday Morning
            </li>
          </ol>
        </div>
        <div>
          <a
            href="https://www.circlehealthgroup.co.uk/consultants/imtiaz-ahmed#ClinicalInterests "
            className=" btn-slide-new"
            style={{ verticalAlign: "middle" }}
            target="_blank"
            rel="noopener noreferrer"
          >
            <span>Appointment </span>
          </a>
        </div>
      </div>

      <div className="book-consultant-contact">
        <section
          className="py-xxl-10 pb-0"
          id="home"
          style={{ background: "rgb(0 0 0 / 70%)", height: "610px" }}
        >
          <div
            className="bg-holder"
            style={{
              backgroundImage: `url(${allergyimg})`,
              backgroundPosition: "top center",
              backgroundSize: "cover",

              //   height: "100vh", // Add a height to ensure background is visible
            }}
          />

          <div className="container ">
            <div className="row  ">
              <div className="paddin-header-contact   text-center ">
                <h1
                  className="  font-base"
                  style={{
                    color: "#810721",
                  }}
                >
                  <span className="strong" style={{ color: "white" }}>
                    {" "}
                    Book a Consultation{" "}
                  </span>
                </h1>
                <div className=" " style={{ color: "white", textAlign:"center", fontSize:"19px" }}>
                  <p className="">
                    I have extensive general dermatology experience in skin
                    surgery, diagnosis and management of eczema, psoriasis,
                    acne, skin cancers, hair loss and nail problems.
                  </p>
                </div>

                {/* <div>
                  <a
                    href="#location"
                    className=" btn-slide "
                    style={{ verticalAlign: "middle" }}
                  >
                    <span>Make an Appointment </span>
                  </a>
                </div>
                <div>
                  <a
                    href="#location"
                    className=" btn-slide-new d-lg-none d-md-none "
                    style={{ verticalAlign: "middle" }}
                  >
                    <span>Appointment </span>
                  </a>
                </div> */}
              </div>
            </div>
          </div>
        </section>
      </div>
      <div className="footer-import footer-import-contact ">
        <QuickLinks />
        <FooterNew />
      </div>
    </div>
  );
};

export default Contact;
